import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const SEOHead = () => {
  const [seo, setSeo] = useState({
    site_title: 'Rentiasi.ro',
    meta_description: '',
    meta_keywords: '',
    og_title: '',
    og_description: '',
    og_image: '',
    canonical_url: 'https://rentiasi.ro',
    head_scripts: ''
  });

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/settings/seo`);
        console.log('SEO settings loaded:', data);
        setSeo(data);
        
        // Directly update document head for better compatibility
        document.title = data.site_title || 'Rentiasi.ro';
        
        // Update or create meta tags
        const updateMeta = (name, content, isProperty = false) => {
          if (!content) return;
          const attr = isProperty ? 'property' : 'name';
          let meta = document.querySelector(`meta[${attr}="${name}"]`);
          if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute(attr, name);
            document.head.appendChild(meta);
          }
          meta.setAttribute('content', content);
        };
        
        updateMeta('description', data.meta_description);
        updateMeta('keywords', data.meta_keywords);
        updateMeta('og:type', 'website', true);
        updateMeta('og:title', data.og_title || data.site_title, true);
        updateMeta('og:description', data.og_description || data.meta_description, true);
        updateMeta('og:url', data.canonical_url, true);
        if (data.og_image) updateMeta('og:image', data.og_image, true);
        updateMeta('twitter:card', 'summary_large_image');
        updateMeta('twitter:title', data.og_title || data.site_title);
        updateMeta('twitter:description', data.og_description || data.meta_description);
        
        // Update canonical link
        if (data.canonical_url) {
          let canonical = document.querySelector('link[rel="canonical"]');
          if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
          }
          canonical.setAttribute('href', data.canonical_url);
        }
      } catch (error) {
        console.log('Using default SEO settings');
      }
    };
    fetchSEO();
  }, []);

  // Helmet is kept for SSR compatibility, but main updates are done via useEffect
  return (
    <Helmet>
      <title>{seo.site_title}</title>
    </Helmet>
  );
};

export default SEOHead;
